declare module FWP {
  function reset(): void;
}

const filterSelectionsInit = (el: HTMLElement) => {
  const searchParmas = new URLSearchParams(window.location.search);
  const searchQuery = searchParmas.get('s');
  const currentUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  const empty: HTMLElement = el.querySelector('.filter-selections__empty');

  if (searchQuery) {
    const searchQueryVisual = document.createElement('span');
    searchQueryVisual.classList.add('facetwp-selection-value');
    searchQueryVisual.classList.add('facetwp-selection-value--searchterm');
    searchQueryVisual.innerText = searchQuery;
    el.appendChild(searchQueryVisual);

    searchQueryVisual.addEventListener('click', () => {
      const newSearchParams = new URLSearchParams(window.location.search);
      searchQueryVisual.remove();
      newSearchParams.set('s', '');
      window.location.href = `${currentUrl}?${newSearchParams}`;
    });
  }

  empty.addEventListener('click', (e) => {
    e.preventDefault();
    FWP.reset();

    if (document.querySelector('.facetwp-selection-value--searchterm')) {
      const newSearchParams = new URLSearchParams(window.location.search);
      document.querySelector('.facetwp-selection-value--searchterm').remove();
      newSearchParams.set('s', '');
      window.location.href = `${currentUrl}?${newSearchParams}`;
    }
  });
};

export default filterSelectionsInit;
